import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap-5';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faPencilAlt } from '@fortawesome/pro-solid-svg-icons';

import { post } from 'helpers/api';

import { Button } from 'components/ui/button';
import CaText from './ca_text';
import { RequestError } from './errors_for_input';
import { getProfileData, PROFILE_OPTIONS, setProfileData } from '../../helpers/preview';
import LoadingSpinner from 'components/ui/loading_spinner';
import { fetchTranslation } from '../../../../helpers/i18n';

export default function SignCaText({ caText, name, readonly, signCaPath, onNext }) {
  const [emailCa, setEmailCa] = useState(false);
  const [agreedToCa, setAgreedToCa] = useState(false);
  const [saving, setSaving] = useState(false);
  const [signingFailed, setSigningFailed] = useState(false);

  const signCa = (e) => {
    e.preventDefault();

    setSaving(true);
    setSigningFailed(false);
    if (readonly) setProfileData({ [PROFILE_OPTIONS.CA_SIGNED]: true });
    const previewProfile = getProfileData();
    post(signCaPath, { signCa: true, emailCa, readonly, previewProfile }).then(() => {
      onNext();
    }).catch(() => {
      if (readonly) setProfileData({ [PROFILE_OPTIONS.CA_SIGNED]: false });
      setSigningFailed(true);
      setSaving(false);
    });
  };

  return (
    <div>
      <div className="text-center mb-4 text-branding">
        <FontAwesomeIcon icon={faLock} size="2x"/>
      </div>
      <h5 className="text-center mb-4">
        <strong>{fetchTranslation('sign_ca_to_view')}</strong>
      </h5>
      <form onSubmit={signCa}>
        <CaText caText={caText}/>
        <Form.Group className="mb-4">
          <Form.Control name="name" readOnly value={name}/>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Check
            checked={agreedToCa}
            id="agree-to-ca"
            label={fetchTranslation('sign_this_ca')}
            name="agree_to_ca"
            type="checkbox"
            onChange={e => setAgreedToCa(e.target.checked)}
          />
        </Form.Group>
        <Form.Group className="mb-4">
          <Form.Check
            checked={emailCa}
            id="email-ca"
            label={fetchTranslation('email_me_copy_of_ca')}
            name="email_ca"
            type="checkbox"
            onChange={e => setEmailCa(e.target.checked)}
          />
        </Form.Group>
        {signingFailed && (
          <RequestError className="mb-4"/>
        )}
        <Button
          className="w-100"
          disabled={!agreedToCa || saving}
          name="save"
          type="submit"
          onClick={signCa}
        >
          {saving ? (
            <>
              <LoadingSpinner flex size="sm" skipTopBuffer />
              {fetchTranslation('signing')}
            </>
          ) : (
            <>
              <FontAwesomeIcon className="me-2" icon={faPencilAlt} />
              {fetchTranslation('sign_ca')}
            </>
          )}
        </Button>
      </form>
    </div>
  );
}

SignCaText.propTypes = {
  caFilePath: PropTypes.string,
  caText: PropTypes.string,
  name: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  signCaPath: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired
};
